export type InputVariant = 'error' | 'warning';

export function getInputVariantClass({
  isError,
  isWarning
}: {
  isError: boolean;
  isWarning: boolean;
}): InputVariant {
  let variantClass = '';
  if (isError) {
    variantClass = 'error';
  }
  if (isWarning) {
    variantClass = 'warning';
  }
  return variantClass as InputVariant;
}
